import _default from './Message';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/collections/Message/index.js
// module id = 644
// module chunks = 0